interface Props {
  width: string
  height: string
}

const NewIconFilter = (props: Props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4H14M4 8H12M6 12H10"
      stroke="#222222"
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default NewIconFilter
